import Revelar from '../components/Revelar'
import { sobreLaMarca } from '../data/contenido'

function SobreLaMarca() {
  return (
    <section
      id="marca"
      aria-labelledby="titulo-marca"
      className="seccion-y border-t border-oro-profundo/20 bg-carbon"
    >
      <div className="contenedor">
        <div className="grid gap-8 sm:gap-12 lg:grid-cols-[1fr_1.2fr] lg:gap-20">
          <Revelar>
            <p className="text-[0.7rem] uppercase tracking-[0.3em] text-oro sm:text-xs sm:tracking-[0.35em]">
              El criadero
            </p>
            <h2 id="titulo-marca" className="mt-4 text-seccion font-light">
              {sobreLaMarca.titulo}
            </h2>
          </Revelar>

          <Revelar retraso={0.1}>
            <div className="space-y-5 sm:space-y-6">
              {sobreLaMarca.parrafos.map((parrafo) => (
                <p
                  key={parrafo.slice(0, 32)}
                  className="text-base leading-relaxed text-marfil-suave/85"
                >
                  {parrafo}
                </p>
              ))}
            </div>
          </Revelar>
        </div>

        {/* Los pilares pasan a tres columnas solo en md: a 640px cada una se
            quedaba en ~190px y el texto se troceaba en cinco líneas.
            El salto es directo de 1 a 3 columnas a propósito — con dos
            columnas, el truco de `gap-px` sobre fondo dorado dejaría una
            celda vacía pintada como un bloque suelto. */}
        <ul className="mt-12 grid gap-px overflow-hidden rounded-sm bg-oro-profundo/30 sm:mt-16 md:grid-cols-3">
          {sobreLaMarca.pilares.map((pilar, i) => (
            <li key={pilar.titulo} className="bg-carbon">
              <Revelar retraso={0.08 * i} className="h-full p-5 sm:p-6">
                <h3 className="font-display text-lg text-oro-claro">
                  {pilar.titulo}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-marfil-suave/80">
                  {pilar.texto}
                </p>
              </Revelar>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default SobreLaMarca
